import React, { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Zap, Loader2 } from "lucide-react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("Token de recuperação inválido");
      return;
    }
    if (password.length < 6) {
      toast.error("A senha deve ter pelo menos 6 caracteres");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("As senhas não coincidem");
      return;
    }

    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Senha redefinida com sucesso");
      navigate("/login");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Erro ao redefinir senha");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 relative overflow-hidden px-4">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(circle at 30% 20%, rgba(37, 211, 102, 0.15), transparent 50%), radial-gradient(circle at 70% 80%, rgba(37, 211, 102, 0.08), transparent 50%)",
        }}
      />
      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-xl bg-[#25D366] flex items-center justify-center">
            <Zap className="w-6 h-6 text-slate-950" strokeWidth={2.5} />
          </div>
          <div>
            <div className="text-2xl font-bold text-slate-50" style={{ fontFamily: "Outfit" }}>
              Cliver CRM
            </div>
            <div className="text-xs uppercase tracking-widest text-slate-500">
              Redefinir senha
            </div>
          </div>
        </div>

        <div className="bg-slate-900/60 backdrop-blur border border-slate-800 rounded-2xl p-7 shadow-2xl">
          <h1 className="text-2xl font-bold text-slate-50 mb-1" style={{ fontFamily: "Outfit" }}>
            Nova senha
          </h1>
          <p className="text-sm text-slate-400 mb-6">Defina uma nova senha para acessar sua conta</p>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-slate-300 text-xs uppercase tracking-wider">Nova senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-slate-800 border-slate-700 text-slate-100 focus:border-[#25D366] mt-1.5 h-11"
              />
            </div>
            <div>
              <Label className="text-slate-300 text-xs uppercase tracking-wider">Confirmar senha</Label>
              <Input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="bg-slate-800 border-slate-700 text-slate-100 focus:border-[#25D366] mt-1.5 h-11"
              />
            </div>

            <Button
              type="submit"
              disabled={busy}
              className="w-full h-11 bg-[#25D366] hover:bg-[#1EAC52] text-slate-950 font-semibold"
            >
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar nova senha"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
